import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/full-flyout';
import styles from './full-flyout.module.scss';

@classNames(styles.component)
export default class SharedFullFlyout extends Super {}
